import React, { useEffect, useState } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import SearchIcon from "@mui/icons-material/Search";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { AiOutlineSearch } from "react-icons/ai";

import { useSelector, useDispatch } from "react-redux";
import { FormControl } from "@mui/material";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import {AdapterDateFns} from "@mui/x-date-pickers/AdapterDateFns"
import Autocomplete from "@mui/lab/Autocomplete";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";

import {
	resetGetVoucherRedeemList,
	getVoucherRedeemListReq
} from "../../redux/actions/getVoucherRedeemListAction";

import { NavLink, Link, useHistory, useNavigate } from "react-router-dom";
import BackButton from "../../components/BackButton/BackButton";
import Util from "../../validation";
import NotificationPopups from "../../NotificationPopup/NotificationPopups";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import { getCustomerIdAndNameList } from "../../redux/actions/getCustomerIdAndNameListAction";
const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

const Redeem = () => {
	const classes = useStyles();
	const navigate = useHistory();
	var date = new Date();
	const [selectedDate, setSelectedDate] = useState(
		new Date(date.getFullYear(), date.getMonth(), 1)
	);
	const [selectedToDate, setSelectedToDate] = useState(new Date());
	const [trackingId, setTrackingId] = useState("");
	const [merchantId, setMerchantId] = useState("");
	const [customerId, setCustomerId] = useState("");
	const [statusType, setStatusType] = useState("");
	const [fromDateTime, setfromDateTime] = useState("00:00:00");
	const [toDateTime, settoDateTime] = useState("23:59:59");
	const [isLoading, setIsLoading] = useState(false);

	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [page, setPage] = useState(0);

	const dispatch = useDispatch();
	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;

	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	// console.log("regenerateTokenRes", regenerateTokenRes);
	var authToken = regenerateTokenRes.data.AuthToken;

	const getVoucherTransactionsRes = useSelector(
		({ getVoucherTransactions }) => getVoucherTransactions
	);

	const getCustomerIdAndNameListRes = useSelector(
		({ getCustomerIdAndNameList }) => getCustomerIdAndNameList
	);
	// console.log("getVoucherTransactionsRes", getVoucherTransactionsRes);

	const [getVoucherRedeemListStatus, setGetVoucherRedeemListStatus] =
		useState(false);

	const [getVoucherRedeemListArray, setgetVoucherRedeemListArray] = useState(
		[]
	);

	const handleChange = ({ target: { name, value } }) => {
		if (name === "trackingId") {
			// setTrackingId(value);
			Util.verifyNumber(value)
				? setTrackingId(value)
				: setTrackingId(trackingId);
		}

		if (name === "merchantId") {
			// setMerchantId(value);
			Util.verifyNumber(value)
				? setMerchantId(value)
				: setMerchantId(merchantId);
		}
		if (name === "customerId") {
			// console.log("CustIDDDD", customerId)
			setCustomerId(value)
		}

		// if (name === "customerId") {
		// 	// setCustomerId(value);
		// 	Util.verifyNumber(value)
		// 		? setCustomerId(value)
		// 		: setCustomerId(customerId);
		// }

		if (name === "statusType") {
			// setStatusType(value);
			setStatusType(value == "Select Status" ? "" : value);
		}

		if (name === "fromDateTime") {
			setfromDateTime(value);
		}

		if (name === "toDateTime") {
			settoDateTime(value);
		}
	};

	// const handleDateChange = (date) => {
	// 	setSelectedDate(date);
	// };
	const handleDateChange = (date) => {
		setSelectedDate(date);
		if(date > selectedToDate){
            setSelectedToDate(date)
        }
	};

	const handleToDateChange = (date) => {
		setSelectedToDate(date);
	};

	function filterWeekends(date) {
		return date.getDay() === 0 || date.getDay() === 6;
	}

	const getVoucherRedeem = () => {
		if (!selectedDate || !selectedToDate || !fromDateTime || !toDateTime) {
			alert("Please enter a Date & Time..!!");
			return; // Stop the execution if "From Date" is not selected
		}
		setIsLoading(true);
		setGetVoucherRedeemListStatus(true);
		const getVoucherRedeemList = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			voucherTransVO: {
				startDate: moment(selectedDate).format("DD/MM/YYYY"),
				startTime: fromDateTime,
				endDate: moment(selectedToDate).format("DD/MM/YYYY"),
				endTime: toDateTime,
				trackingId: trackingId,
				toId: merchantId,
				customerId: customerId.split("-")[0] || "",
				status: statusType
			}
		};

		return dispatch(getVoucherRedeemListReq(getVoucherRedeemList, authToken));
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			// getVoucherRedeem();
		}
	}, [regenerateTokenRes.data.status]);

	const getVoucherRedeemDetailsListRes = useSelector(
		({ getVoucherRedeemList }) => getVoucherRedeemList
	);

	useEffect(() => {
		if (getVoucherRedeemListStatus) {
			if (getVoucherRedeemDetailsListRes.data.status == "success") {
				setIsLoading(false);
				setgetVoucherRedeemListArray(
					[].concat(getVoucherRedeemDetailsListRes.data.voucherTransVOList)
				);
			}
			if (getVoucherRedeemDetailsListRes.data.status == "Failed") {
				setIsLoading(false);
				setgetVoucherRedeemListArray(getVoucherRedeemDetailsListRes.data)(
					false
				);
				setGetVoucherRedeemListStatus(false);
				NotificationPopups(
					"error",
					"Failed",
					getVoucherRedeemDetailsListRes.data.status
				);
				if (
					getVoucherRedeemDetailsListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getVoucherRedeemDetailsListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getVoucherRedeemDetailsListRes.data.status == "failed") {
				setIsLoading(false);
				setgetVoucherRedeemListArray(getVoucherRedeemDetailsListRes.data)(
					false
				);
				setGetVoucherRedeemListStatus(false);
				NotificationPopups(
					"error",
					"Failed",
					getVoucherRedeemDetailsListRes.data.status
				);
				if (
					getVoucherRedeemDetailsListRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getVoucherRedeemDetailsListRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getVoucherRedeemDetailsListRes.data.status == "NOT FOUND") {
				setIsLoading(false);
				setgetVoucherRedeemListArray(getVoucherRedeemDetailsListRes.data);
				setGetVoucherRedeemListStatus(false);
				NotificationPopups(
					"error",
					"Failed",
					getVoucherRedeemDetailsListRes.data.status
				);
			}
		}
	}, [getVoucherRedeemDetailsListRes.data.status]);

	useEffect(() => {
		if (getVoucherRedeemDetailsListRes.data.status == "success") {
			setPage(0);
		}
	}, [getVoucherRedeemDetailsListRes.data.status]);

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const sendCustomerId = (id) => {
		navigate.push({
			pathname: `/index/redeemDetails`,
			search: `?userId=${id}`
		});
	};
	useEffect(() => {
		if (getCustomerIdAndNameListRes.data.status === "Success") {
			//console.log("lissttt", getCustomerIdAndNameListRes.data.currencyList)
		}
	}, [getCustomerIdAndNameListRes.data.status])

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			const getCustomerIdAndNameReq = {
				loginDetails: {
					walletOwnerId: regenerateTokenRes.data.partnerId || ""
				},
				actionCustomerMasterRequestVO: {
					customerNameOrId: ""
				}
			};

			dispatch(getCustomerIdAndNameList(getCustomerIdAndNameReq, authToken));
		}
	}, [regenerateTokenRes.data.status]);


	const filterOptionsL = (options, { inputValue }) => {
		//console.log(options, inputValue, "optionsss")
		if (inputValue.length < 3) {
			return [];
		}

		const filterOptionsList = options.filter(
			(option) =>
				option.includes(inputValue) ||
				""
		);

		return filterOptionsList.slice(0, 20);
	}
	return (
		<>
			<Layout>
				<Card>
					{/* <BackButton /> */}
					<Grid
						container
						spacing={2}
						style={{ padding: "25px", marginTop: "2rem" }}
					>
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<FormControl fullWidth>
								 <LocalizationProvider dateAdapter={AdapterDateFns}>
									<DatePicker
										label="From Date"
										format="MM/dd/yyyy"
										value={selectedDate}
										onChange={handleDateChange}
										disableFuture={true}
									/>
						 </LocalizationProvider>
							</FormControl>
						</Grid>

						<Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="HH:MM:SS"
								type="tel"
								variant="standard"
								fullWidth
								value={fromDateTime}
								name="fromDateTime"
								onChange={handleChange}
								style={{ marginTop: "3px" }}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>
						</Grid>

						<Grid item xs={12} sm={12} md={3} lg={3}>
							<FormControl fullWidth>
								 <LocalizationProvider dateAdapter={AdapterDateFns}>
									<DatePicker
										label="To Date"
										format="MM/dd/yyyy"
										value={selectedToDate}
										onChange={handleToDateChange}
										disableFuture={true}
										minDate={selectedDate}
									/>
								  </LocalizationProvider>
							</FormControl>
						</Grid>

						<Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="HH:MM:SS"
								type="tel"
								variant="standard"

								fullWidth
								value={toDateTime}
								name="toDateTime"
								onChange={handleChange}
								style={{ marginTop: "3px" }}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>
						</Grid>
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="Tracking Id"
								type="text"
								variant="standard"

								fullWidth
								value={trackingId || ""}
								name="trackingId"
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>
						</Grid>
						<Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="Merchant Id"
								type="tel"
								variant="standard"

								fullWidth
								value={merchantId}
								name="merchantId"
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							/>
						</Grid>

						{/* <Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								autoFocus
								margin="dense"
								id="name"
								label="Customer ID"
								type="tel"
								fullWidth
								variant="standard"

								value={customerId}
								name="customerId"
								onChange={handleChange}
							/>
						</Grid> */}
						<Grid item xs={12} sm={12} md={3} lg={3}>
								<Autocomplete
									id="combo-box-demo"
									options={[].concat(
										getCustomerIdAndNameListRes.data.currencyList || [""]
									)}
									getOptionLabel={(option) => option}
									filterOptions={filterOptionsL}
									value={customerId}
									onChange={handleChange}
									onInputChange={(event, newInputValue) => {
										setCustomerId(newInputValue);
									}}
									renderInput={(params) => (
										<TextField
											autoFocus
											margin="dense"
											id="name"
											label="Customer ID"
											style={{ marginTop: "3px" }}
											// required
											type="tel"
											fullWidth
											{...params}

											name="customerId"

											variant="standard"
											sx={{
												"& .MuiInput-underline:before": {
												  borderBottomColor: "gray", // White color for the underline before focus
												},
												"& .MuiInput-underline:hover:not(.Mui-disabled):before": {
												  borderBottomColor: "gray", // White color on hover
												},
												"& .MuiInput-underline:after": {
												  borderBottomColor: "gray", // White color after focus
												},
											  }}
										/>
									)}
								/>
							</Grid>

						<Grid item xs={12} sm={12} md={3} lg={3}>
							<TextField
								select
								autoFocus
								margin="dense"
								id="name"
								label="Status"
								type="name"
								fullWidth
								variant="standard"
								name="statusType"
								// value={statusType || ""}
								defaultValue={"Select Status" || statusType}
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							>
								<MenuItem value="Select Status" selected="Select Status">
									Select Status
								</MenuItem>
								<MenuItem value="REDEEM_SUCCESSFUL">Redeem Successful</MenuItem>
								<MenuItem value="REDEEM_FAILED">Redeem Failed</MenuItem>
							</TextField>
						</Grid>
					</Grid>

					<Grid
						container
						style={{
							padding: "10px",
							marginTop: "1.5rem",
							marginBottom: "15px"
						}}
					>
						<Grid item md={5}>
							{/* <Button
                style={{
                  marginLeft: "0.7rem",
                  backgroundColor: "#00b9f5",
                  color: "white",
                }}
                endIcon={<AiOutlineSearch />}
                variant="contained"
                onClick={getVoucherRedeem}
              >
                Search
              </Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={getVoucherRedeem}
							>
								Search <SearchIcon />
							</CustomButton>
						</Grid>
						<Grid item md={7}></Grid>
					</Grid>
				</Card>

				{isLoading ? (
					<LoadingSpinner />
				) : getVoucherRedeemListArray.length == undefined ||
					!getVoucherRedeemListStatus ? (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography
									variant="body1"
									style={{ fontWeight: "700" }}
									className="themeText"
								>
									Redeem List
								</Typography>
							</Grid>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Alert
									className="my-3 tableHeaderColor"
									variant="secondary"
								// style={{ backgroundColor: "#00b9f5", color: "white" }}
								>
									No Records Found!
								</Alert>
							</Grid>
						</Grid>
					</Card>
				) : (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography
									variant="body1"
									style={{ fontWeight: "700" }}
									className="themeText"
								>
									Redeem List
								</Typography>
							</Grid>
							<TableContainer component={Paper} className="my-3">
								<Table
									className={classes.table}
									size="small"
									aria-label="a dense table"
								>
									<TableHead>
										<TableRow className="tableHeaderColor">
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Tracking Id{" "}
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												{" "}
												Status
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												{" "}
												Merchant Id
											</TableCell>

											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Customer Id
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Redeem Amount
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Redeem Currency
											</TableCell>

											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Voucher Amount
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Voucher Currency
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Timestamp
											</TableCell>
										</TableRow>
									</TableHead>

									<TableBody>
										{getVoucherRedeemListArray &&
											[]
												.concat(getVoucherRedeemListArray)
												.slice(
													page * rowsPerPage,
													page * rowsPerPage + rowsPerPage
												)
												.map((row, index) => (
													<TableRow key={row.trackingId}>
														{/* <TableCell align="center">
                              <CustomButton
                                style={{
                                  marginTop: "1rem",
                                  marginLeft: "1rem",
                                }}
                                onClick={() => sendCustomerId(row.trackingId)}
                              >
                                {row.trackingId}
                              </CustomButton>
                            </TableCell> */}
														<TableCell
															align="center"
															className="themeText"
															style={{
																marginTop: "1rem",
																// marginLeft: "rem",
																// color: "#00b9f5",
																cursor: "pointer",
																fontWeight: "600"
															}}
															onClick={() => sendCustomerId(row.trackingId)}
														>
															{row.trackingId === '' ? '-' : row.trackingId}
														</TableCell>
														<TableCell align="center">{row.status === '' ? '-' : row.status}</TableCell>
														<TableCell align="center">{row.merchantId === '' ? '-' : row.merchantId}</TableCell>
														<TableCell align="center">
															{row.customerId === '' ? '-' : row.customerId}
														</TableCell>
														<TableCell align="center">
															{row.redeemAmount === '' ? '-' : row.redeemAmount}
														</TableCell>
														<TableCell align="center">
															{row.currency === '' ? '-' : row.currency}
														</TableCell>

														<TableCell align="center">
															{row.voucherAmount === '' ? '-' : row.voucherAmount}
														</TableCell>
														<TableCell align="center">
															{row.voucherCurrency === '' ? '-' : row.voucherCurrency}
														</TableCell>
														<TableCell align="center">
															{row.timestamp === '' ? '-' : row.timestamp}
														</TableCell>
													</TableRow>
												))}
									</TableBody>
								</Table>
								<TablePagination
									rowsPerPageOptions={[5, 10, 25]}
									component="div"
									count={getVoucherRedeemListArray.length}
									rowsPerPage={rowsPerPage}
									page={page}
									onPageChange={handleChangePage}
									onRowsPerPageChange={handleChangeRowsPerPage}
								/>
							</TableContainer>
						</Grid>
					</Card>
				)}
			</Layout>
		</>
	);
};

export default Redeem;
